// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + ({"702":"story","715":"list"}[chunkId] || chunkId) + "-" + {"42":"2511ac1b60522c0962cc","260":"90afa6fda7b3878f2fb6","702":"be32d60973cc0596065d","715":"1854c6796ca9d595ae5a"}[chunkId] + ".css";
};